@if (!minimized) {
  <div class="panel">
    <div class="border-b border-gray-200">
      <div class="px-8 h-20 items-center flex gap-3">
        <div class="text-[13px] font-medium tracking-[0.3px] text-headline whitespace-nowrap overflow-hidden text-ellipsis">
          {{ sidebarFilter | titleByTasksFilter: containerName : true }}
          @if (isAdvancedSearchApplied()) {
            – Search Results
          }
        </div>
        <div class="grow"></div>
        <!-- [MUST-003] 'Debug' button hidden per task; uncomment to re-enable
        <div
          class="debug"
          [class.active]="debug"
          (click)="doDebug()"
          >
          {{ debug || 'Debug' }}
        </div>
        -->
        @if (selectedTab === 'tasks') {
          <app-context-menu-state-indicator
            svgIcon="filters"
            appTasksListContextMenu
            [appTasksListContextMenuWithSidebarFilters]="true"
            [appTasksListContextMenuWithAdvancedSearch]="true"
            />
        }
        @if (selectedTab === 'projects') {
          <app-context-menu-state-indicator
            svgIcon="filters"
            appProjectsListContextMenu
            [appProjectsListContextMenuWithSidebarFilters]="true"
            [appProjectsListContextMenuWithAdvancedSearch]="true"
            />
        }
      </div>
      @if (listState === 'tabs') {
        <app-tabs
          class="panel-heading-tabs"
          [values]="tabs"
          [value]="selectedTab"
          (valueChange)="handleSelectedTabChange($event)"
          />
      }
    </div>
        <div class="panel-list">
          <!-- `tasksFilters` is the tuple's product and the tenant gate withholds it until the member
               tenant is known. Binding `undefined` OVERWRITES the list's own default and `getSection`
               then reads `filters.followedOnTop` off it — the TypeError notes measured 3/3 before it
               gained this same guard (#1065 r2 ROW 7). -->
          @if (selectedTab === 'tasks' && tasksFilters) {
            <app-tasks-list
              [filters]="tasksFilters"
              [tenantItems]="taskTenantItems"
              [openOnRemoval]="false"
              [debug]="debug"
              [showLocationBadge]="isAdvancedSearchApplied()"
              (loadInProgress)="loading = $event"
              (openTask)="handleClickTask($event)"
              (openSubtask)="handleClickTask($event)"
              (clickTask)="handleClickTask($event)"
              (doubleClickTask)="handleDoubleClickTask($event)"
              />
          }
          @if (selectedTab === 'projects' && projectsFilters) {
            <app-projects-list
              [filters]="projectsFilters"
              [debug]="debug"
              (loadInProgress)="loading = $event"
              (openProject)="handleClickProject($event)"
              (openTask)="handleClickTask($event)"
              (clickProject)="handleClickProject($event)"
              (doubleClickProject)="handleDoubleClickProject($event)"
              />
          }
        </div>
      </div>
    }
